import { requestBuilder } from "../../../services/api"

const mtResourceURL = "https://api.beta.mytravo.net"
const mtApiURL = "https://api.beta.mytravo.net/v2"
const POST = "POST"
const GET = "GET"
const POST_FORM = "POST-FORM"

export const API = {
  // Add calls here
  getAllWorkforces: token => {
    return requestBuilder(`${mtApiURL}/refmoe/get`, GET, undefined, token)
  },
  getAllWorks: token => {
    return requestBuilder(`${mtApiURL}/refouvrage/get`, GET, undefined, token)
  },
  getAllFactures: token => {
    return requestBuilder(`${mtApiURL}/invoice/get`, GET, undefined, token)
  },

  createWorkforce: (token, workforceData) => {
    return requestBuilder(
      `${mtApiURL}/refmoe/create/${JSON.stringify(workforceData)}`,
      GET,
      undefined,
      token,
      workforceData
    )
  },

  createWork: (token, workData) => {
    return requestBuilder(
      `${mtApiURL}/refouvrage/create/${JSON.stringify(workData)}`,
      GET,
      undefined,
      token,
      workData
    )
  },

  createInvoice: (token, invoiceData) => {
    return requestBuilder(
      `${mtApiURL}/invoice/create/${JSON.stringify(invoiceData)}`,
      GET,
      undefined,
      token,
      invoiceData
    )
  },

  // Update
  updateWorkforce: (token, workforceData) => {
    return requestBuilder(
      `${mtApiURL}/refmoe/update/${JSON.stringify(workforceData)}`,
      GET,
      undefined,
      token,
      workforceData
    )
  },

  updateWork: (token, workData) => {
    return requestBuilder(
      `${mtApiURL}/refouvrage/update/${JSON.stringify(workData)}`,
      GET,
      undefined,
      token,
      workData
    )
  },

  // Delete
  deleteWorforce: (token, workforceData) => {
    return requestBuilder(
      `${mtApiURL}/refmoe/delete/${JSON.stringify(workforceData)}`,
      GET,
      undefined,
      token,
      workforceData
    )
  },

  deleteWork: (token, workData) => {
    return requestBuilder(
      `${mtApiURL}/refouvrage/delete/${JSON.stringify(workData)}`,
      GET,
      undefined,
      token,
      workData
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Pro/service/proApi.js